<template>
  <div class="interface" v-if="interfacesData">
    <v-card outlined>
      <HeaderPanel
        header-text="Interface events details"
        :headingRight="dateRange"
      >
        <div slot="header-right">
        </div>
      </HeaderPanel>
      <v-card class="ma-4" flat>
        <div class="bar-charts-listings" v-if="interfacesData.length">
          <bar-chart-tile
            v-for="item in interfacesData"
            :organisation-name="organisationName"
            :key="item.name"
            :data="item"
            :timeStart="timestampStart"
            :timeEnd="timestampEnd"
            :client="currentOrg"
            :singleChart="!interfacesLenght > 1"
          />
        </div>
        <p class="no-results" v-else>
          No interface stats available in the selected time period
        </p>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { dashboard } from '@/mixins/dashboard.js';
import { mapState } from 'vuex';

export default {
  name: 'InterfaceEvents',
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
    BarChartTile: () => import('@/components/BarChartTile/BarChartTile.vue'),
  },
  mixins: [
    dashboard('dashboard'),
  ],
  data() {
    return {
      organisationName: this.$route.query.org_name,
    }
  },
  computed: {
    ...mapState({
      interfacesData: state => state.orgs.interfacesDashboard,
    }),
    interfaceID() {
      return this.$route.query.i ? this.$route.query.i : '*';
    },
    interfacesLenght() {
      if (!this.interfacesData) {
        return 0;
      }
      return this.interfacesData.length;
    },
  },
  methods: {
    updateData() {
      this.$store.dispatch('getInterfacesData', {
        clientHash: this.$route.query.c,
        timeStart: this.timestampStart,
        timeEnd: this.timestampEnd,
        interfaceID: this.interfaceID,
      });
    },
  },
  created() {
    this.updateData();
  }
};
</script>
